import { combineReducers } from "redux";

import User from "./User";
import Posts from "./Posts";
import NewCase from "./NewCase";
import Notifications from "./Notifications";
import ConfirmationModal from "./ConfirmationModal";
import Search from "./Search";
import Ads from "./Ads";
import UI from "./UI";
import Collections from "./Collections";
import { reducer as notifReducer } from "redux-notifications";
import { reducer as Form } from "redux-form";
/* redux little router reduce */
import { reduxRoutes } from "../util/Router/routes";
import IS_CLIENT_RENDERED from "../util/isClientRendered";

const commonReducers = {
  user: User,
  posts: Posts,
  notifications: Notifications,
  newCase: NewCase,
  confirmationModal: ConfirmationModal,
  notifs: notifReducer,
  search: Search,
  form: Form,
  ads: Ads,
  ui: UI,
  collections: Collections
}

export const getReducers = (req) => {
  if (IS_CLIENT_RENDERED) {
    //client
    const routerForBrowser = require("redux-little-router").routerForBrowser;
    const { reducer: Router } = routerForBrowser({ routes: reduxRoutes });

    return combineReducers({
      ...commonReducers,
      router: Router,
    });
  }
  
  //server
  const routerForExpress = require("redux-little-router").routerForExpress;
  const { reducer: Router } = routerForExpress({ routes: reduxRoutes, request: req });

  return combineReducers({
    ...commonReducers,
    router: Router,
  });

}


// WEBPACK FOOTER //
// ./src/reducers/index.js